import { render, staticRenderFns } from "./live-contact.vue?vue&type=template&id=39dc5ae1&scoped=true&"
import script from "./live-contact.vue?vue&type=script&lang=js&"
export * from "./live-contact.vue?vue&type=script&lang=js&"
import style0 from "./live-contact.vue?vue&type=style&index=0&id=39dc5ae1&prod&lang=scss&scoped=true&"
import style1 from "./live-contact.vue?vue&type=style&index=1&id=39dc5ae1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dc5ae1",
  null
  
)

export default component.exports